/**
 * Most stock movements one inventory validation may write. A till sale waits on the Article rows
 * the validation holds until its last movement. A year-end inventory has no second count before
 * its closing date, so it has more room and is validated outside till hours.
 */
export const INVENTORY_MOVEMENT_LIMITS = { standard: 2500, yearEnd: 5000 };
/**
 * Most lines one inventory session may hold: the start writes them in one transaction and the
 * validation adjusts every line with a variance in another. A year-end inventory covers the whole
 * tenant and cannot be split by depot, so its bound follows its movement bound.
 */
export const INVENTORY_LINE_LIMITS = { standard: 2000, yearEnd: 5000 };
//# sourceMappingURL=inventory.js.map